import { render, staticRenderFns } from "./RegAccount.vue?vue&type=template&id=732e26ff&scoped=true&"
import script from "./RegAccount.vue?vue&type=script&lang=js&"
export * from "./RegAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732e26ff",
  null
  
)

export default component.exports